import { IconACH } from './Ach';
import { IconBook } from './Book';
import { IconCheck } from './Check';
import { IconDebit } from './Debit';
import { IconInternationalWire } from './InternationalWire';
import { IconRealtime } from './Realtime';
import { IconWire } from './Wire';
import { IconAdmin } from './Admin';
import { IconStablecoin } from './Stablecoin';
export const IconTransfer = {
    ACH: IconACH,
    Admin: IconAdmin,
    Book: IconBook,
    Check: IconCheck,
    Debit: IconDebit,
    InternationalWire: IconInternationalWire,
    Realtime: IconRealtime,
    Wire: IconWire,
    Stablecoin: IconStablecoin,
};
//# sourceMappingURL=index.js.map